import {useRouter} from 'next/router';
import {useEffect} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {ROLES_NAMES} from '@/src/app/constants/roles';
import useUserActions from '@/src/app/store/user/useUserActions';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import ClinicAccountSettingsLayout from '@/src/profile/accountSettings/components/ClinicAccountSettingsLayout';

import fetchUserAction from '../../../signUp/paymentDetails/utils/fetchUserAction';
import AccountSettingsLayout from '../components/AccountSettingsLayout';

const AccountSettings = () => {
  const {user: userData, setUserData} = useUserActions();
  const {push} = useRouter();
  const {SIGN_IN_ROUTE} = useRoutePaths();

  useEffect(() => {
    const fetchUser = async () => {
      if (userData.user.id === null) {
        const {status, responseBody} = await fetchUserAction();

        if (status === RESPONSE_STATUSES.SUCCESS) {
          setUserData(responseBody);
        } else {
          push(SIGN_IN_ROUTE.getLink());
        }
      }
    };

    fetchUser();
  }, [userData]);

  if (userData.user.id === null) {
    return null;
  }

  return userData.user.type === ROLES_NAMES.CLINIC ? (
    <ClinicAccountSettingsLayout />
  ) : (
    <AccountSettingsLayout userData={userData} />
  );
};

export default AccountSettings;
